import React, { useState, useEffect } from 'react';

// import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
// import RenderProfilePic from '../../extras/RenderProfilePic';
// import { getFullName } from '../../utils';
import LoadingCircleIcon from '../../icons/LoadingCircle';
import VerifyProfile from './VerifyProfile';
import { unverifiedCoachesSelector } from '../../redux/reducers/coachReducer';
import { loadAllUnverifiedCoaches } from '../../redux/actions/coachActions';
import VerificationTable from './utils/table';

export default function CoachVerification() {
  const [filterByStatus, setFilterByStatus] = useState('All');
  const [filteredData, setFilteredData] = useState([]);
  const [verifyProfile, setVerifyProfile] = useState();
  const users = useSelector(unverifiedCoachesSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    async function loadCoaches() {
      await dispatch(loadAllUnverifiedCoaches());
    }
    loadCoaches();
  }, [verifyProfile]);

  if (!users)
    return (
      <div className='h-full flex m-auto'>
        <LoadingCircleIcon iconStyle='w-16 mt-64 text-blue-500 m-auto' />
      </div>
    );

  useEffect(() => {
    getDataByFilter();
  }, [filterByStatus, users]);

  const getDataByFilter = () => {
    if (filterByStatus === 'All') {
      setFilteredData(users);
    } else if (filterByStatus === 'NEW') {
      setFilteredData(users.filter((user) => user.status === 'NEW'));
    } else if (filterByStatus === 'ON_HOLD') {
      setFilteredData(users.filter((user) => user.status === 'ON_HOLD'));
    } else if (filterByStatus === 'UPDATED') {
      setFilteredData(users.filter((user) => user.status === 'UPDATED'));
    }
  };

  if (verifyProfile) {
    return (
      <VerifyProfile user={verifyProfile} setVerifyProfile={setVerifyProfile} />
    );
  } else {
    return (
      <div>
        <h1
          className='text-2xl font-bold mb-6'
          style={{ color: 'var(--text-primary)' }}
        >
          Coach Verification
        </h1>
    
        <div className='flex items-center justify-between mb-4'>
          <span
            className='text-sm font-medium'
            style={{ color: 'var(--text-secondary)' }}
          >
            All ({users.length})
          </span>
          <select
            onChange={({ target }) => setFilterByStatus(target.value)}
            value={filterByStatus || ''}
            className='px-3 py-2 text-sm rounded-md cursor-pointer focus:outline-none'
            style={{
              backgroundColor: 'var(--input-background)',
              border: '1px solid var(--input-border)',
              color: 'var(--input-text)',
            }}
          >
            <option value='All'>All Statuses</option>
            <option value='ON_HOLD'>On Hold</option>
            <option value='NEW'>New</option>
            <option value='UPDATED'>Updated</option>
          </select>
        </div>
    
        <VerificationTable
          rowData={filteredData}
          setVerifyProfile={setVerifyProfile}
          setFilterByStatus={setFilterByStatus}
        />
      </div>
    );
  }
}
